import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import { LoadSalesStatisticListSuccessAction, salesStatisticListActionTypes } from '../actions/sales-statistic-list';
import { SalesStatistic } from '../models/sales-statistic';

export interface SalesStatisticListState {
  array: SalesStatistic[];
  count: number;
}

const initialState: SalesStatisticListState = {
  array: [],
  count: 0,
};

export function SalesStatisticListReducer(state: SalesStatisticListState = initialState, action: Action): SalesStatisticListState {
  switch (action.type) {
    case salesStatisticListActionTypes.LOAD_SUCCESS:
      return handleLoadSalesStatisticListSuccessAction(state, action);
    case salesStatisticListActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    default:
      return state;
  }
}
function handleLoadSalesStatisticListSuccessAction(state: SalesStatisticListState, action: LoadSalesStatisticListSuccessAction): SalesStatisticListState {
  const newState: SalesStatisticListState = {
    ... state,
    array: action.payload.array,
    count: action.payload.count
  };
  return newState;
}

function handleLoadErrorActions(state: SalesStatisticListState): SalesStatisticListState {
  return state;
}

export const salesStatisticListStateSelectors = {
  array: (state: SalesStatisticListState) => _.get(state, 'array', []),
  count: (state: SalesStatisticListState) => _.get(state, 'count', 0)
};
